module.exports = __webpack_public_path__ + "static/media/Marcus.35dcaffe.png";